import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { Lesson } from '@lyceo/homi/shared/util-models';

export const LESSON_FEATURE_KEY: string = 'lesson';

export type LessonState = EntityState<Lesson>;

export const lessonAdapter: EntityAdapter<Lesson> =
  createEntityAdapter<Lesson>();

export const initialLessonState: LessonState = lessonAdapter.getInitialState();

const reducer: ActionReducer<LessonState, Action> =
  createReducer(initialLessonState);

export function lessonReducer(
  state: LessonState | undefined,
  action: Action,
): LessonState {
  return reducer(state, action);
}
